// extracted by mini-css-extract-plugin
export default {"container":"T3-z","heading":"U3-z","links":"V3-z","copy":"W3-z","subCopy":"X3-z","linksLeft":"Y3-z","linksCenter":"Z3-z","linksRight":"_3-z","link":"a4-z","onlyLink":"b4-z"};